module.exports = __webpack_public_path__ + "img/38abba495f3e43d29b21541913a10371-1440.ff4747e9.jpg";